import React from 'react';
import LgmButton from './LgmButton';
import { GRAY_500 } from 'theme/grayScale';

interface ProductsNoResultsOverlayProps {
  suggestFdaSources: {
    searchTerm: string;
    onSwitchToFdaSources: () => void;
  };
}

/**
 * Custom `slots.noRowsOverlay` for the Products grid
 * (docs/features/fda-source-product-search.md, Task FSS-009).
 *
 * Only ever wired in (see ProductsRowGroupingDataGrid.tsx's `gridSlots`)
 * for a zero-result *basic* search with a non-empty term (Requirement 4
 * AC) — every other empty scenario (advanced search, filters, no search
 * at all) omits the `noRowsOverlay` slot key entirely so DataGridPremium's
 * own default overlay renders instead.
 */
const ProductsNoResultsOverlay = ({
  suggestFdaSources,
}: ProductsNoResultsOverlayProps) => {
  const { searchTerm, onSwitchToFdaSources } = suggestFdaSources;

  return (
    <div style={styles.container}>
      <p style={styles.message}>
        No internal results for &ldquo;{searchTerm}&rdquo;.
      </p>
      <LgmButton
        onClick={onSwitchToFdaSources}
        data-testid="switch-to-fda-sources-button">
        Search FDA Sources for &ldquo;{searchTerm}&rdquo;
      </LgmButton>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.75rem',
    height: '100%',
    padding: '2rem',
    textAlign: 'center',
  },
  message: {
    fontSize: '0.875rem',
    color: GRAY_500,
    margin: 0,
  },
};

export default ProductsNoResultsOverlay;
